export var createAdminApi = function (baseUrl, http) {
    var base = "".concat(baseUrl, "/admin");
    var api = {
        appVersion: function () {
            return http.get("".concat(base, "/app/version"));
        }
    };
    return api;
};
//# sourceMappingURL=index.js.map